// extracted by mini-css-extract-plugin
export default {"root":"ExtensionCard_root__nwn01","rootCentered":"ExtensionCard_rootCentered__CRHyj","rootIcon":"ExtensionCard_rootIcon__dhul8","rootSpan":"ExtensionCard_rootSpan__-6d7t"};